import { FavoriteButton } from "@/features/toggle-favorite"

interface PostCardActionsProps {
	postId: string
}

export function PostCardActions({ postId }: PostCardActionsProps) {
	return <FavoriteButton postId={postId} variant="icon" />
}
